import Button from "@pathwright/ui/src/components/button/Button"
import DropGate from "@pathwright/ui/src/components/drop/DropGate"
import { media } from "@pathwright/ui/src/components/utils/styles"
import styled from "styled-components"
import { FEATURE_PERMISSION_DISABLED } from "../../../feature/constants"
import Registrations from "../../../registration/list"
import { getPlatformUrl } from "../../../utils/urls"
import { useCommunityContext } from "../../Community"
import useCommunityAreaFeaturePermission from "../useCommunityAreaFeaturePermission"
import useCommunityAreas from "../useCommunityAreas"
import CommunityMembersFilter from "./CommunityMembersFilter"

const StyledButton = styled(Button)`
  ${media.min.phone`  
    .Community__members & {
      position: absolute;
      top: 20px;
      right: 20px;
      /* layer above the SwitchButton */
      z-index: 1002;
    }
  `}
`

const CommunityMembersDrop = () => {
  return (
    <DropGate
      title="Member Directory unlocks soon"
      description={`As part of Season 1, we'll add a Member Directory and other Community features.`}
      link={getPlatformUrl("/library/season-i-cohort/211635/path/")}
      linkLabel="Join the Season Path"
    />
  )
}

const CommunityMembers = ({ inverted, toInvite }) => {
  const { cohortId } = useCommunityContext()
  const { featurePermission } = useCommunityAreaFeaturePermission()
  const { selectedArea } = useCommunityAreas()

  // NOTE: toInvite currently passed as prop as a form of permissions
  // const cohort = useQuery(GROUP_QUERY, { variables: { id: cohortId } })
  // const toInvite = getGroupInviteUrl(
  //   get(cohort, "data.group.resource.slug"),
  //   get(cohort, "data.group.id"),
  //   "community"
  // )

  if (featurePermission === FEATURE_PERMISSION_DISABLED) {
    return <CommunityMembersDrop />
  }

  return (
    <Registrations.Container cohortId={cohortId}>
      <CommunityMembersFilter />
      {/* <CommunityMembersFilter inverted={inverted}>
        {!!toInvite && (
          <StyledButton styleType="primary" to={toInvite}>
            <Pathicon icon="group-plus" />
            <span> </span>
            Invite
          </StyledButton>
        )}
      </CommunityMembersFilter> */}
      <Registrations.List inverted={inverted}>
        {selectedArea.renderBlankSlate}
      </Registrations.List>
    </Registrations.Container>
  )
}

CommunityMembers.displayName = "CommunityMembers"

export default CommunityMembers
